.modal-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 736px;
    height: 442px;
}
